"use strict";
/*
Copyright 2018 - 2022 The Alephium Authors
This file is part of the alephium project.

The library is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

The library is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with the library. If not, see <http://www.gnu.org/licenses/>.
*/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contract = exports.token = exports.script = exports.val = exports.unlockScript = exports.lockupScript = exports.contractOutput = exports.boolCodec = exports.Codec = exports.assetOutput = void 0;
__exportStar(require("./array-codec"), exports);
exports.assetOutput = __importStar(require("./asset-output-codec"));
__exportStar(require("./bigint-codec"), exports);
__exportStar(require("./bytestring-codec"), exports);
var codec_1 = require("./codec");
Object.defineProperty(exports, "Codec", { enumerable: true, get: function () { return codec_1.Codec; } });
Object.defineProperty(exports, "boolCodec", { enumerable: true, get: function () { return codec_1.boolCodec; } });
__exportStar(require("./compact-int-codec"), exports);
exports.contractOutput = __importStar(require("./contract-output-codec"));
__exportStar(require("./contract-output-ref-codec"), exports);
__exportStar(require("./either-codec"), exports);
__exportStar(require("./input-codec"), exports);
__exportStar(require("./instr-codec"), exports);
exports.lockupScript = __importStar(require("./lockup-script-codec"));
exports.unlockScript = __importStar(require("./unlock-script-codec"));
exports.val = __importStar(require("./val"));
__exportStar(require("./timestamp-codec"), exports);
__exportStar(require("./method-codec"), exports);
__exportStar(require("./option-codec"), exports);
exports.script = __importStar(require("./script-codec"));
__exportStar(require("./signature-codec"), exports);
__exportStar(require("./int-as-4bytes-codec"), exports);
exports.token = __importStar(require("./token-codec"));
__exportStar(require("./transaction-codec"), exports);
__exportStar(require("./unsigned-tx-codec"), exports);
exports.contract = __importStar(require("./contract-codec"));
